import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { GetWorkoutByUserIdServices } from "../../../core/store/sport/workout/thunk";

const Program = () => {
  const dispatch = useDispatch();
  const [workoutPlan, setWorkoutPlan] = useState([]);

  useEffect(() => {
    try {
      const authUser = JSON.parse(sessionStorage.getItem('authUser'));
      const userId = authUser?.data?.data?.userId;
      
      if (!userId) {
        console.error('ID utilisateur non trouvé');
        return;
      }
      
      dispatch(GetWorkoutByUserIdServices(userId));
    } catch (error) {
      console.error('Erreur lors de la récupération de l\'ID utilisateur:', error);
    }
  }, [dispatch]);

  const workout = useSelector(state => state.workout.workout);
  

  return (
    <div>Program</div>
  )
}

export default Program;